import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import './checks.scss'

const CheckCepim = ({ cepimCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])
  const hasChecks = Array.isArray(cepimCheck?.checkDetails) && cepimCheck?.checkDetails?.length > 0
  const checkLength = cepimCheck?.checkDetails?.length || 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:cepim')}</Typography>

        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} />
      </Paper>

      <CheckDetailTitle
        email={cepimCheck?.email}
        status={cepimCheck?.status}
        createdAt={cepimCheck?.createdAt}
        updatedAt={cepimCheck?.updatedAt}
      />

      {!Array.isArray(cepimCheck?.checkDetails) && cepimCheck?.checkDetails?.informação && (
        <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
          <Typography variant="subtitle1">{t('common:information')}</Typography>
          <Typography variant="subtitle3">{cepimCheck.checkDetails.informação ?? '---'}</Typography>
        </Paper>
      )}

      {hasChecks &&
        cepimCheck.checkDetails.map((element, index) => (
          <TimelineDotLine key={index}>
            <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
              <div className="c-detail-grid">
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:date')}</Typography>
                  <Typography variant="subtitle3">{element.dataReferencia ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:reason')}</Typography>
                  <Typography variant="subtitle3">{element.motivo ?? '---'}</Typography>
                </div>
                <div className="c-detail-col">
                  <Typography variant="subtitle1">{t('common:higherBody')}</Typography>
                  <Typography variant="subtitle3">{element.orgaoSuperior?.nome ?? '---'}</Typography>
                </div>
                <div className="c-detail-col">
                  <Typography variant="subtitle1">{t('common:legalPerson')}</Typography>
                  <Typography variant="subtitle3">{element.pessoaJuridica?.nome ?? '---'}</Typography>
                </div>
              </div>
            </Paper>
          </TimelineDotLine>
        ))}
    </>
  )
}

export default CheckCepim
